import { split86012String } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';
import { SCHEDULE_TIME_FORMAT } from '../EventSchedule';
import { EventScheduleDataEvent } from '../types';
import React from 'react';
import { styled, TextV2 } from '@withjoy/joykit';

type EventScheduleItemProps = {
  event: EventScheduleDataEvent;
  onSelect?: (data: EventScheduleDataEvent) => void;
};

export const EventItem = styled.div`
  margin-bottom: 1.5rem;
  position: relative;
`;

export const EventScheduleItem = (props: EventScheduleItemProps) => {
  const { event, onSelect } = props;

  // Custom formatting options (e.g., without seconds)
  const customTimeFormatter = new Intl.DateTimeFormat('en-US', SCHEDULE_TIME_FORMAT);
  const startDate = event.startTimeISO8601TZ ? split86012String(event.startTimeISO8601TZ) : null;
  const endDate = event.endTimeISO8601TZ ? split86012String(event.endTimeISO8601TZ) : null;

  return (
    <EventItem
      key={event.id}
      onClick={e => {
        e.stopPropagation();
        onSelect?.(event);
      }}
    >
      <TextV2
        typographyVariant="label1"
        color="textSecondary"
      >
        {startDate && `${customTimeFormatter.format(startDate.datetime)}`}
        {endDate && ` - ${customTimeFormatter.format(endDate.datetime)}`}
      </TextV2>
      <TextV2>{event.name}</TextV2>
    </EventItem>
  );
};
